import * as roles from '../../../services/access/roles';
import {messages} from '../../common/Translations';
import {plainJSTranslator} from "../../../common/PlainJSTranslator";
import * as subscriptionTypes from '../../company/subscriptionType';

export default [
    {
        id: 'nyhed',
        to: '/nyhed/skab',
        title: plainJSTranslator.formatMessage(messages.sideBarCreateItemArticle),
        roles: [roles.PARTNER_ROLE],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,

        ],
    },
    {
        id: 'jobopslag',
        to: '/jobopslag/skab',
        title: plainJSTranslator.formatMessage(messages.sideBarCreateItemJob),
        roles: [roles.PARTNER_ROLE],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
        ],
    },
    {
        id: 'maskine',
        to: '/maskine/skab',
        title: plainJSTranslator.formatMessage(messages.sideBarCreateItemMachine),
        roles: [roles.PARTNER_ROLE],
        // roles: [roles.FBG_WEBMASTER],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.REGULAR_MINI_TYPE,
        ],
    },
    {
        id: 'park',
        to: '/park/skab',
        title: 'Maskinpark',
        roles: [roles.PARTNER_ROLE],
        subscriptionTypes: [
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.MASKINSTATIONER_MINI,
        ],
    },
    {
        id: 'udlejning',
        to: '/rent/skab',
        title: 'Udlejning',
        roles: [roles.PARTNER_ROLE],
        subscriptionTypes: [
            subscriptionTypes.MASKINSTATIONER_REGULAR,
        ],
    },
    {
        id: 'galleri',
        to: '/galleri/skab',
        title: 'Galleri',
        roles: [roles.PARTNER_ROLE],
        subscriptionTypes: [
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.MASKINSTATIONER_MINI,
        ],
    },
    {
        id: 'ydelse',
        to: '/ydelse/skab',
        title: plainJSTranslator.formatMessage(messages.sideBarCreateItemService),
        roles: [roles.PARTNER_ROLE],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.REGULAR_MINI_TYPE,
        ],
    },
    {
        id: 'kurser',
        to: '/kurser/skab',
        title: plainJSTranslator.formatMessage(messages.sideBarCreateItemCourse),
        roles: [roles.PARTNER_ROLE],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.REGULAR_MINI_TYPE,
        ],
    },
    {
        id: 'kontaktperson',
        to: '/kontaktperson/skab',
        title: plainJSTranslator.formatMessage(messages.sideBarCreateItemContactPerson),
        roles: [roles.PARTNER_ROLE],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.REGULAR_MINI_TYPE,
        ],
    },
    {
        id: 'kataloger',
        to: '/kataloger/skab',
        title: plainJSTranslator.formatMessage(messages.sideBarCreateItemCatalog),
        roles: [roles.PARTNER_ROLE],
        subscriptionTypes: [
            subscriptionTypes.REGULAR_TYPE,
            subscriptionTypes.DEALER_TYPE,
            subscriptionTypes.MASKINSTATIONER_REGULAR,
            subscriptionTypes.MASKINSTATIONER_MINI,
            subscriptionTypes.REGULAR_MINI_TYPE,
        ],
    },
];


// WEBPACK FOOTER //
// ./web/src/components/navigation/items/createItems.jsx